import Vue from "vue";
import VueRouter from "vue-router";
import { isMobile as detectMobile } from "@/utils/device";
// 静态导入路由-用于直接导入（常用一些导航栏/首页/登录页经常出现的页面）
// 1.移动端
import LayoutM from "@/views/layout";
import Home from "@/views/layout/home.vue";
import Clue from "@/views/layout/clue.vue";
import Follow from "@/views/layout/follow.vue";
import Category from "@/views/layout/category.vue";
import Cart from "@/views/layout/cart.vue";
import User from "@/views/layout/user.vue";
import bindGoods from "@/views/bind/bindGoods.vue";

// 2.pc
import PC from "@/views/layout/pc.vue";
import LayoutP from "@/views/pc/layout";
import pcmy from "@/views/pc/my";
import pcHome from "@/views/pc/layout/home.vue";
import pcAutumnHome from "@/indexlogo/IndexLogoHome.vue";
import pcHome2 from "@/views/pc/layout/featured.vue";
import pcCshHome from "@/views/pc/layout/cshome.vue";
import pcClue from "@/views/pc/layout/clue.vue";
import pcFollow from "@/views/pc/layout/follow.vue";
import pcUser from "@/views/pc/layout/user.vue";
import pcBindGoods from "@/views/pc/bind/bindGoods.vue";

import store from "@/store";
import { Dialog, Toast } from "vant";
import { Message, MessageBox } from "element-ui";
import {
  isWikiReviewerAccount,
  rememberWikiReviewerAccess,
} from "@/utils/wikiReviewer";
import { getWikiReviewAccess } from "@/api/xunzhiKb";
import { priceChannelFlags } from "@/services/price-channel/feature-flags";
import { pcPriceChannelRoutes } from "./priceChannelRoutes";

const isMobile = detectMobile();

const showRealnameConfirm = (from) => {
  const message = "《网络安全法》规定，实名才可发布信息，前往实名认证！";
  const goRealname = () => {
    router.push({
      path: isMobile ? "/realname" : "/pc/realname",
    });
  };
  const handleCancel = () => {
    console.log(from.path);
    if (from.path == "/home" || from.path == "/") {
      return;
    }
    if (isMobile) {
      router.replace({
        path: "/home",
      });
    }
  };

  if (isMobile) {
    Dialog.confirm({
      title: "温馨提示",
      message,
    })
      .then(goRealname)
      .catch(handleCancel);
    return;
  }

  MessageBox.confirm(message, "温馨提示", {
    confirmButtonText: "前往实名认证",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(goRealname)
    .catch(handleCancel);
};

// type: "my" 表示我的页面-是为了区分pc端个人中心主页

// 动态导入路由-用于懒加载（特定场景才会触发的页面）
// 1.移动端
// 谈判人-跟单模块
const PendingFollow = () => import("@/views/follow/tpr/pendingFollow.vue");
const swPendingFollow = () => import("@/views/follow/sw/pendingFollow.vue");
const applybroker = () => import("@/views/layout/applybroker.vue");

// 商品详情页
const ProDetail = () => import("@/views/prodetail");
//购物车
const ShopCart = () => import("@/views/shopCart/index.vue");
//购买意向单
const BuyNow = () => import("@/views/shopCart/buyNow/index.vue");

// 线索模块
const MobilePublishCenter = () => import("@/views/publish/index.vue");
const MobileQuickOrder = () => import("@/views/order/QuickOrder.vue");
const ClueDetail = () => import("@/views/clue/ClueDetail.vue");
const ClueEdit = () => import("@/views/clue/ClueEdit.vue");
const realname = () => import("@/views/my/realname.vue");

// 发布商品-谈判人完善货源信息
const PublishGoods = () => import("@/views/follow/tpr/publishGoods.vue");

// 销售谈判人-修改购买意向单
const EditPreOrder = () =>
  import("@/views/follow/tpr/buyerConfirmPreOrder.vue");

// 采购谈判人-确认购买意向单
const ConfirmPreOrder = () =>
  import("@/views/follow/tpr/sellerConfirmPreOrder.vue");
// 商务-交易合同
const GenerateTradeContract = () =>
  import("@/views/follow/sw/generateTradeContract.vue");
const confirmTradeContract = () =>
  import("@/views/follow/sw/confirmTradeContract.vue");

// 移动端生成销售订单
const fastTradeContract = () =>
  import("@/views/follow/sw/fastTradeContract.vue");
// 移动端审核销售订单 / 发起、审核销售合同
const confirmFastTradeContract = () =>
  import("@/views/follow/sw/confirmFastTradeContract.vue");
// 快捷生成采购合同
const fastPurchaseContract = () =>
  import("@/views/follow/sw/fastPurchaseContract.vue");

// 确认快捷采购合同
const confirmFastPurchaseContract = () =>
  import("@/views/follow/sw/confirmFastPurchaseContract.vue");
// 移动端发起付款审批
const fastPurchasePayment = () =>
  import("@/views/follow/sw/fastPurchasePayment.vue");
// 移动端审核付款审批
const confirmFastPurchasePayment = () =>
  import("@/views/follow/sw/confirmFastPurchasePayment.vue");
// 移动端发起/审核付款方式审批与 INV 审批
const selectPaymentMethod = () =>
  import("@/views/follow/sw/selectPaymentMethod.vue");
const confirmFastTradeInvoice = () =>
  import("@/views/follow/sw/confirmFastTradeInvoice.vue");
// 移动端销售出库单审核
const outboundOrderAudit = () =>
  import("@/views/follow/sw/outboundOrderAudit.vue");
const outboundOrderList = () =>
  import("@/views/follow/sw/outboundOrderList.vue");
// 查看快捷销售合同详情
// const fastTradeContractDetail = () =>
//   import("@/views/follow/sw/fastTradeContractDetail.vue");
// // 查看快捷采购合同详情
// const fastPurchaseContractDetail = () =>
//   import("@/views/follow/sw/fastPurchaseContractDetail.vue");

// 跟单详情
const tprFollowDetail = () => import("@/views/follow/tpr/tprFollowDetail");
const swFollowDetail = () => import("@/views/follow/sw/swFollowDetail");
const myAi = () => import("@/views/myAi/index.vue");

// 个人中心
const myBalance = () => import("@/views/my/myBalance.vue");
const myEvaluate = () => import("@/views/my/myEvaluate.vue");
const myTransactionOrder = () => import("@/views/my/myTransactionOrder.vue");
const myGoods = () => import("@/views/my/myGoods.vue");
const myGoodsLibrary = () => import("@/views/my/goodsLibrary.vue");
const myMessageCenter = () => import("@/views/my/messageCenter.vue");
const myTransactionOrderDetail = () =>
  import("@/views/my/myTransactionOrderDetail.vue");
const myBuyOrderList = () => import("@/views/my/myBuyOrderList.vue");
const myBuyOrderDetail = () => import("@/views/my/myBuyOrderDetail.vue");
const mySaleOrderList = () => import("@/views/my/mySaleOrderList.vue");
const mySaleOrderDetail = () => import("@/views/my/mySaleOrderDetail.vue");
const myPublishClue = () => import("@/views/my/myPublishClue.vue");
const mySaleGoods = () => import("@/views/my/mySaleGoods.vue");
const myPreOrderList = () => import("@/views/my/myPreOrderList.vue");
const myYanHuo = () => import("@/views/my/myYanHuo.vue");
const myYanHuoDetail2 = () => import("@/views/my/myYanHuoDetail2.vue");
const myPreOrderDetail = () => import("@/views/my/myPreOrderDetail.vue");

// 未处理
const Login = () => import("@/views/login");
const Search = () => import("@/views/search");
const SearchList = () => import("@/views/search/list");

const preOrderDetail = () => import("@/views/follow/sw/preOrderDetail");
const Buy = () => import("@/views/prodetail/preOrderSuccess.vue");
const Pay = () => import("@/views/pay");
const MyOrder = () => import("@/views/myorder");
const myCreateOrder = () => import("@/views/follow/sw/myCreateOrder.vue");
const getFollowSuccess = () => import("@/views/follow/getFollowSuccess.vue");
const publishSuccess = () => import("@/views/clue/publishSuccess.vue");
const PreOrderSuccess = () => import("@/views/prodetail/preOrderSuccess");
const sw = () => import("@/views/follow/sw/index");
const externalPay = () => import("@/views/externalPay/index.vue");
const externalPayInfo = () => import("@/views/externalPay/externalPayInfo.vue");

const myOrderIntention = () => import("@/views/my/myOrderIntention.vue");

const myFollowOrderList = () => import("@/views/my/myFollowOrderList.vue");
const myDetails = () => import("@/views/my/myDetails.vue");
const mySupplierList = () => import("@/views/my/supplierList.vue");

const myHome = () => import("@/views/my/myHome.vue");
const ParameterMonitor = () => import("@/views/debug/ParameterMonitor.vue");

// 2.pc端
//  接单模块
const pcPendingFollow = () => import("@/views/pc/follow/tpr/pendingFollow.vue");
const pcswPendingFollow = () =>
  import("@/views/pc/follow/sw/pendingFollow.vue");
const pcapplybroker = () => import("@/views/pc/layout/applybroker.vue");
// 商品详情页
const pcProDetail = () => import("@/views/pc/prodetail");
//购物车
const pcShopCart = () => import("@/views/pc/shopCart/index.vue");
//购买意向单
const pcBuyNow = () => import("@/views/pc/shopCart/buyNow/index.vue");
// 商品详情快捷下单，与发布中心的精选发布业务分离。
const pcQuickOrder = () => import("@/views/pc/order/QuickOrder.vue");
// 发布中心
const pcPublishCenter = () => import("@/views/pc/publish/index.vue");
const pcClueDetail = () => import("@/views/pc/clue/ClueDetail.vue");
const pcClueEdit = () => import("@/views/pc/clue/ClueEdit.vue");
const pcSupplyPublish = () => import("@/views/pc/clue/SupplyPublish.vue");
const pcDemandPublish = () => import("@/views/pc/clue/DemandPublish.vue");
const pcSimpleSupplyPublish = () =>
  import("@/views/pc/clue/SimpleSupplyPublish.vue");
const pcSimpleDemandPublish = () =>
  import("@/views/pc/clue/SimpleDemandPublish.vue");
const pcSupplyList = () => import("@/views/pc/clue/SupplyList.vue");
const pcDemandList = () => import("@/views/pc/clue/DemandList.vue");
const pcSupplyDetail = () => import("@/views/pc/clue/SupplyDetail.vue");
//供需
const pcSupplyDemandPublish = () =>
  import("@/views/pc/clue/SupplyDemandPublish.vue");
const pcSupplyDemandHall = () => import("@/views/pc/clue/SupplyDemandHall.vue");
const pcSupplyDemandHallDetail = () =>
  import("@/views/pc/clue/SupplyDemandHallDetail.vue");
const pcSupplierJoin = () => import("@/views/pc/brand/SupplierJoin.vue");
const pcBrand = () => import("@/views/pc/brand/index.vue");
const pcBrandJoin = () => import("@/views/pc/brand/BrandJoin.vue");
const pcBrandDetail = () => import("@/views/pc/brand/BrandDetail.vue");
const pcPublishGoods = () => import("@/views/pc/follow/tpr/publishGoods.vue");
const pcrealname = () => import("@/views/pc/my/realname.vue");
const pcAbout = () => import("@/views/pc/about/index.vue");
const pcProducts = () => import("@/views/pc/products/index.vue");
const pcWiki = () => import("@/views/pc/wiki/index.vue");
const pcWikiDetail = () => import("@/views/pc/wiki/detail.vue");
const pcWikiCommunity = () => import("@/views/pc/wiki/community.vue");
const pcWikiQuestionDetail = () => import("@/views/pc/wiki/questionDetail.vue");
const pcWikiQuestions = () => import("@/views/pc/wiki/questions.vue");
const pcWikiTopic = () => import("@/views/pc/wiki/topic.vue");
const pcmyWiki = () => import("@/views/pc/my/myWiki.vue");
const pcmyWikiCollection = () => import("@/views/pc/my/myWikiCollection.vue");
const pcmyWikiQuestions = () => import("@/views/pc/my/myWikiQuestions.vue");
const pcmyWikiPublish = () => import("@/views/pc/my/myWikiPublish.vue");
// 规格书发布模块
const pcSpecificationManage = () =>
  import("@/views/pc/specification/SpecificationManage.vue");
const pcSpecificationPublish = () =>
  import("@/views/pc/specification/specificationPublish.vue");
const pcSpecificationPublishSuccess = () =>
  import("@/views/pc/specification/publishSuccess.vue");
const pcSpecificationDetail = () =>
  import("@/views/pc/specification/detail.vue");
// 购买意向单
const pcEditPreOrder = () =>
  import("@/views/pc/follow/tpr/buyerConfirmPreOrder.vue");
const pcConfirmPreOrder = () =>
  import("@/views/pc/follow/tpr/sellerConfirmPreOrder.vue");
// 交易合同
const pcGenerateTradeContract = () =>
  import("@/views/pc/follow/sw/generateTradeContract.vue");
const pcconfirmTradeContract = () =>
  import("@/views/pc/follow/sw/confirmTradeContract.vue");
// 快捷生成销售合同
const pcFastTradeContract = () =>
  import("@/views/pc/follow/sw/fastTradeContract.vue");
// 确认快捷销售合同
const pcConfirmFastTradeContract = () =>
  import("@/views/pc/follow/sw/confirmFastTradeContract.vue");
// 查看快捷销售合同详情
const pcFastTradeContractDetail = () =>
  import("@/views/pc/follow/sw/fastTradeContractDetail.vue");
// 查看快捷采购合同详情
const pcFastPurchaseContractDetail = () =>
  import("@/views/pc/follow/sw/fastPurchaseContractDetail.vue");
// 快捷生成采购合同
const pcFastPurchaseContract = () =>
  import("@/views/pc/follow/sw/fastPurchaseContract.vue");
// 确认快捷采购合同
const pcConfirmFastPurchaseContract = () =>
  import("@/views/pc/follow/sw/confirmFastPurchaseContract.vue");
// 发起采购付款流程
const pcFastPurchasePayment = () =>
  import("@/views/pc/follow/sw/fastPurchasePayment.vue");
// 确认采购付款流程
const pcConfirmFastPurchasePayment = () =>
  import("@/views/pc/follow/sw/confirmFastPurchasePayment.vue");
// 选择付款方式
const pcSelectPaymentMethod = () =>
  import("@/views/pc/follow/sw/selectPaymentMethod.vue");

// 确认销售发票
const pcConfirmFastTradeInvoice = () =>
  import("@/views/pc/follow/sw/confirmFastTradeInvoice.vue");
// 销售出库单审核（前端展示流程）
const pcOutboundOrderAudit = () =>
  import("@/views/pc/follow/sw/outboundOrderAudit.vue");

// 跟单详情
const pctprFollowDetail = () => import("@/views/pc/follow/tpr/tprFollowDetail");
const pcswFollowDetail = () => import("@/views/pc/follow/sw/swFollowDetail");

// AI模块
const pcmyAi = () => import("@/views/pc/myAi/index.vue");
const pcSearch = () => import("@/views/pc/search/index.vue");

// 个人中心
const pcmyBalance = () => import("@/views/pc/my/myBalance.vue");
const pcmyEvaluate = () => import("@/views/pc/my/myEvaluate.vue");
const pcReportData = () => import("@/views/pc/my/reportData.vue");
const pcmyTransactionOrder = () =>
  import("@/views/pc/my/myTransactionOrder.vue");
const pcmyGoods = () => import("@/views/pc/my/myGoods.vue");
const pcGoodsLibrary = () => import("@/views/pc/my/goodsLibrary.vue");
const pcmyTransactionOrderDetail = () =>
  import("@/views/pc/my/myTransactionOrderDetail.vue");
const pcmyBuyOrderList = () => import("@/views/pc/my/myBuyOrderList.vue");
const pcmyBuyOrderDetail = () => import("@/views/pc/my/myBuyOrderDetail.vue");
const pcmySaleOrderList = () => import("@/views/pc/my/mySaleOrderList.vue");
const pcmySaleOrderDetail = () => import("@/views/pc/my/mySaleOrderDetail.vue");
const pcmyPublishClue = () => import("@/views/pc/my/myPublishClue.vue");
const pcmySaleGoods = () => import("@/views/pc/my/mySaleGoods.vue");
const pcmyPreOrderList = () => import("@/views/pc/my/myPreOrderList.vue");
const pcmyContractList = () => import("@/views/pc/my/myContractList.vue");
const pcmyYanHuo = () => import("@/views/pc/my/myYanHuo.vue");
const pcmyYanHuoDetail2 = () => import("@/views/pc/my/myYanHuoDetail2.vue");
const pcmyPreOrderDetail = () => import("@/views/pc/my/myPreOrderDetail.vue");
const pcContentPublish = () => import("@/views/pc/my/ContentPublish.vue");
const pcSupplyDemandBatch = () => import("@/views/pc/my/SupplyDemandBatch.vue");
const pcShopHome = () => import("@/views/pc/my/shopHome.vue");
const pcMessageCenter = () => import("@/views/pc/my/messageCenter.vue");
const pcSupplierList = () => import("@/views/pc/my/supplierList.vue");
const pcBid = () => import("@/views/pc/bid/index.vue");
const pcBidPublish = () => import("@/views/pc/bid/publish/index.vue");
const pcCustomerManagement = () =>
  import("@/views/pc/my/CustomerManagement.vue");
const pcMemberLevel = () => import("@/views/pc/my/MemberLevel.vue");
const pcSupplyDemandMemberIdentity = () =>
  import("@/views/pc/my/SupplyDemandMemberIdentity.vue");
const pcBiddingManagement = () => import("@/views/pc/my/BiddingManagement.vue");
const pcBidAuditCenter = () => import("@/views/pc/my/BidAuditCenter.vue");
const pcBidAuditReview = () => import("@/views/pc/my/BidAuditReview.vue");
const pcMyBrand = () => import("@/views/pc/my/myBrand.vue");
const pcCompanyHome = () => import("@/views/pc/company/CompanyHome.vue");

// 重新封装的路由跳转方法（保存原生的 push 和 replace 方法）
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 路径适配核心逻辑（抽成通用函数，避免重复代码）
const adaptPath = (originalPath) => {
  // 新搜索首页是电脑、平板和手机共用的独立入口，始终保留统一 URL。
  if (originalPath === "/pc/autumn-home" || originalPath === "/autumn-home") {
    return "/pc/autumn-home";
  }
  let targetPath;
  if (isMobile) {
    // 移动端：移除可能存在的/pc前缀
    targetPath = originalPath.startsWith("/pc")
      ? originalPath.replace("/pc", "")
      : originalPath;
  } else {
    // PC端：补充/pc前缀（避免重复添加）
    targetPath = originalPath.startsWith("/pc")
      ? originalPath
      : `/pc${originalPath}`;
  }
  // 确保路径以"/"开头
  return targetPath.startsWith("/") ? targetPath : `/${targetPath}`;
};

// 重写 push 方法（增加错误捕获）
VueRouter.prototype.push = function (routeInfo) {
  // 处理参数（支持字符串路径或路由对象）
  const originalRoute =
    typeof routeInfo === "string" ? { path: routeInfo } : { ...routeInfo };

  const originalPath = originalRoute.path;
  if (!originalPath) {
    console.error("push 路径不能为空！");
    return originalPush.call(this, routeInfo);
  }

  // 适配路径并调用原生方法，同时捕获所有导航错误
  return originalPush
    .call(this, {
      ...originalRoute,
      path: adaptPath(originalPath),
    })
    .catch(() => {});
};

// 重写 replace 方法（同样增加错误捕获）
VueRouter.prototype.replace = function (routeInfo) {
  // 处理参数（支持字符串路径或路由对象）
  const originalRoute =
    typeof routeInfo === "string" ? { path: routeInfo } : { ...routeInfo };

  const originalPath = originalRoute.path;
  if (!originalPath) {
    return originalReplace.call(this, routeInfo).catch(() => {});
  }

  // 适配路径并调用原生方法，同时捕获所有导航错误
  return originalReplace
    .call(this, {
      ...originalRoute,
      path: adaptPath(originalPath),
    })
    .catch(() => {});
};
Vue.use(VueRouter);

const Layout = isMobile ? LayoutM : LayoutP;
const priceChannelPersonalRoutes = [
  "identity",
  "activity",
  "watchlists",
  "certifications",
  "submissions",
  "reviews",
  "results",
].map((section) => ({
  path:
    section === "identity"
      ? "/pc/my/pricechannel"
      : `/pc/my/pricechannel/${section}`,
  component: () =>
    import("@/views/pc/my/pricechannel/PriceChannelBusiness.vue"),
  meta: {
    title: "价格频道",
    type: "my",
    requiresAuth: true,
    priceChannelSection: section,
  },
}));
if (priceChannelFlags.readSource === "spring-api") {
  for (const surface of ["company", "qualifications", "company-preview"]) {
    priceChannelPersonalRoutes.push({
      path: `/pc/my/pricechannel/${surface}`,
      component: () =>
        import("@/views/pc/my/pricechannel/BusinessLegacySurface.vue"),
      props: { surface },
      meta: { title: "价格频道", type: "my", requiresAuth: true },
    });
  }
}
// 移动端路由
const routes = [
  ...[
    {
      path: "/pc",
      component: { render: (h) => h("router-view") },
      children: [
        ...pcPriceChannelRoutes,
        ...(priceChannelFlags.readSource === "spring-api"
          ? priceChannelPersonalRoutes
          : []),
      ],
    },
  ],
  {
    path: "/autumn-home",
    component: pcAutumnHome,
    meta: {
      title: "先搜",
      hideLayoutTop: true,
      hideTabbar: true,
    },
  },
  {
    path: "/",
    component: Layout,
    // 设置默认子路由，访问/时直接显示home组件
    children: [
      {
        path: "", // 空路径表示默认子路由
        component: Home,
        meta: { title: "大宗交易商城" },
      },
    ],
  },
  {
    path: "/layout",
    component: Layout,
    children: [
      { path: "/home", component: Home, meta: { title: "大宗交易商城" } },
      {
        path: "/featured",
        component: Home,
        meta: { title: "精选", hideTabbar: false },
      },
      {
        path: "/category",
        component: Category,
        meta: { title: "商务订购跟单（接单）" },
      },
      // { path: '/clueFollow', component: ClueFollow },
      { path: "/follow", component: Follow, meta: { title: "跟单" } },
      { path: "/user", component: User, meta: { title: "我的" } },
      { path: "/clue", component: Clue, meta: { title: "供求" } },
      { path: "/sw", component: sw, meta: { title: "跟单" } },
      { path: "/login", component: Login, meta: { title: "登录" } },
    ],
  },
  { path: "/cart", component: Cart, meta: { title: "购物车" } },
  // { path: "/login", component: Login, meta: { title: "登录" } },
  { path: "/search", component: Search, meta: { title: "搜索" } },
  { path: "/searchlist", component: SearchList, meta: { title: "商品列表" } },
  // 首页移动端导航使用无 /pc 前缀的明确入口，避免路由守卫去掉前缀后
  // 命中不存在的路由而显示空白页。现有频道页面均已包含窄屏响应式样式。
  { path: "/bid", component: pcBid, meta: { title: "竞价" } },
  { path: "/wiki", component: pcWiki, meta: { title: "百科" } },
  { path: "/brand", component: pcBrand, meta: { title: "品牌中心" } },
  { path: "/info", component: pcSupplyDemandHall, meta: { title: "供需信息" } },
  {
    path: "/info/publish",
    component: pcSupplyDemandPublish,
    meta: { title: "供需发布" },
  },
  {
    path: "/info/detail/:id",
    component: pcSupplyDemandHallDetail,
    meta: { title: "供需详情" },
  },
  {
    path: "/brand/supplier-join",
    component: pcSupplierJoin,
    meta: { title: "企业入驻" },
  },
  { path: "/pc", component: PC, meta: { title: "pc" } },
  //动态路由传参
  {
    path: "/prodetail/:id",
    component: ProDetail,
    meta: { title: "商品详情" },
  },
  {
    path: "/shopcart",
    component: ShopCart,
    meta: { title: "购物车" },
  },
  {
    path: "/buynow",
    component: BuyNow,
    meta: { title: "购买意向单" },
  },
  {
    path: "/preOrderDetail/:id",
    component: preOrderDetail,
    meta: { title: "跟单详情" },
  },
  {
    path: "/bindGoods",
    component: bindGoods,
    meta: { title: "绑定商品" },
  },
  {
    path: "/follow/tprFollowDetail/:id",
    component: tprFollowDetail,
    meta: { title: "谈判人跟单详情" },
  },
  {
    path: "/follow/swFollowDetail/:id",
    component: swFollowDetail,
    meta: { title: "商务跟单详情" },
  },
  { path: "/pay", component: Pay },
  { path: "/buy", component: Buy },
  { path: "/preOrderSuccess", component: PreOrderSuccess },
  { path: "/myorder", component: MyOrder },
  {
    path: "/follow/pendingFollow",
    component: PendingFollow,
    meta: { title: "谈判接单" },
  },
  {
    path: "/follow/swPendingFollow",
    component: swPendingFollow,
    meta: { title: "商务接单" },
  },
  {
    path: "/follow/getFollowSuccess",
    component: getFollowSuccess,
    meta: { title: "商务接单成功" },
  },
  {
    path: "/follow/tpr/confirmPreOrder",
    component: ConfirmPreOrder,
    meta: { title: "确认意向单" },
  },
  {
    path: "/follow/tpr/editPreOrder",
    component: EditPreOrder,
    meta: { title: "修改意向单" },
  },
  { path: "/sw/myCreateOrder", component: myCreateOrder },
  {
    path: "/source/publish",
    component: MobilePublishCenter,
    meta: { title: "发布中心", hideTabbar: true },
  },
  {
    path: "/source/publish/fast",
    redirect: (to) => ({
      path: "/source/publish",
      query: { ...to.query, tab: "featured" },
    }),
  },
  {
    path: "/product/fastBuy",
    component: MobileQuickOrder,
    meta: { title: "快捷下单", hideTabbar: true },
  },
  {
    path: "/source/publishSuccess",
    component: publishSuccess,
    meta: { title: "发布货源线索成功" },
  },
  {
    path: "/source/publishGoods",
    component: PublishGoods,
    meta: { title: "发布货源商品" },
  },
  {
    path: "/clue/clueDetail",
    component: ClueDetail,
    meta: { title: "货源详情" },
  },
  {
    path: "/clue/clueEdit",
    component: ClueEdit,
    meta: { title: "货源编辑" },
  },
  {
    path: "/follow/generateTradeContract",
    component: GenerateTradeContract,
    meta: { title: "生成交易合同" },
  },
  {
    path: "/follow/confirmTradeContract",
    component: confirmTradeContract,
    meta: { title: "确认交易合同" },
  },
  {
    path: "/follow/fastTradeContract",
    component: fastTradeContract,
    meta: { title: "生成销售订单" },
  },
  {
    path: "/follow/confirmFastTradeContract",
    component: confirmFastTradeContract,
    meta: { title: "销售订单/合同审批" },
  },
  {
    path: "/follow/fastPurchaseContract",
    component: fastPurchaseContract,
    meta: { title: "快捷生成采购合同" },
  },
  {
    path: "/follow/confirmFastPurchaseContract",
    component: confirmFastPurchaseContract,
    meta: { title: "快捷确认采购合同" },
  },
  {
    path: "/follow/fastPurchasePayment",
    component: fastPurchasePayment,
    meta: { title: "发起付款审批" },
  },
  {
    path: "/follow/confirmFastPurchasePayment",
    component: confirmFastPurchasePayment,
    meta: { title: "审核付款审批" },
  },
  {
    path: "/follow/selectPaymentMethod",
    component: selectPaymentMethod,
    meta: { title: "付款方式审批" },
  },
  {
    path: "/follow/uploadPaymentVoucher",
    component: selectPaymentMethod,
    meta: { title: "上传付款凭证" },
  },
  {
    path: "/follow/confirmFastTradeInvoice",
    component: confirmFastTradeInvoice,
    meta: { title: "INV审批" },
  },
  {
    path: "/follow/outboundOrderList",
    component: outboundOrderList,
    meta: { title: "出库单列表" },
  },
  {
    path: "/follow/outboundOrderAudit",
    component: outboundOrderAudit,
    meta: { title: "出库单审核" },
  },
  {
    path: "/externalPay",
    component: externalPay,
    meta: { title: "对外支付" },
  },
  {
    path: "/externalPayInfo",
    component: externalPayInfo,
    meta: { title: "对外支付" },
  },

  {
    path: "/myxg/myPublishClue",
    component: myPublishClue,
    meta: { title: "我发布的线索" },
  },
  {
    path: "/myxg/myOrderIntention",
    component: myOrderIntention,
    meta: { title: "我的意向单" },
  },
  {
    path: "/myxg/myPreOrderList",
    component: myPreOrderList,
    meta: { title: "我的意向订购" },
  },

  {
    path: "/myxg/myBuyOrderList",
    component: myBuyOrderList,
    meta: { title: "我的购买订单" },
  },
  {
    path: "/myxg/myBuyOrderDetail",
    component: myBuyOrderDetail,
    meta: { title: "订单详情" },
  },
  {
    path: "/myxg/myYanHuoDetail2",
    component: myYanHuoDetail2,
    meta: { title: "验货详情2", type: "my" },
  },

  {
    path: "/myxg/mySaleOrderList",
    component: mySaleOrderList,
    meta: { title: "我的销售订单" },
  },
  {
    path: "/myxg/mySaleOrderDetail",
    component: mySaleOrderDetail,
    meta: { title: "订单详情" },
  },
  {
    path: "/myxg/myEvaluate",
    component: myEvaluate,
    meta: { title: "评价" },
  },

  {
    path: "/myxg/myYanHuo",
    component: myYanHuo,
    meta: { title: "我的验货" },
  },
  {
    path: "/myxg/myFollowOrderList",
    component: myFollowOrderList,
    meta: { title: "跟单订单" },
  },
  {
    path: "/myxg/myPreOrderDetail",
    component: myPreOrderDetail,
    meta: { title: "商品订单详情" },
  },
  { path: "/myxg/myDetails", component: myDetails, meta: { title: "详情" } },
  {
    path: "/myxg/mySaleGoods",
    component: mySaleGoods,
    meta: { title: "我的销售商品" },
  },
  {
    path: "/myxg/supplierList",
    component: mySupplierList,
    meta: { title: "供应商管理" },
  },
  { path: "/realname", component: realname, meta: { title: "实名认证" } },
  {
    path: "/applybroker",
    component: applybroker,
    meta: { title: "申请成为谈判人" },
  },

  {
    path: "/my/myBalance",
    component: myBalance,
    meta: { title: "我的钱包" },
  },
  {
    path: "/myxg/myTransactionOrder",
    component: myTransactionOrder,
    meta: { title: "交易订单" },
  },
  {
    path: "/myxg/myGoods",
    component: myGoods,
    meta: { title: "商品中心" },
  },
  {
    path: "/myxg/goodsLibrary",
    component: myGoodsLibrary,
    meta: { title: "商品库" },
  },
  {
    path: "/myxg/messageCenter",
    component: myMessageCenter,
    meta: { title: "消息管理", hideTabbar: true },
  },
  {
    path: "/myxg/myTransactionOrderDetail",
    component: myTransactionOrderDetail,
    meta: { title: "交易订单详情" },
  },
  { path: "/my/personal-info", component: () => import("@/views/my/personalInfo.vue"), meta: { title: "个人资料", hideTabbar: true } },
  {
    path: "/my/myHome",
    component: myHome,
    meta: { title: "个人主页" },
  },
  {
    path: "/myAi",
    component: myAi,
    meta: { title: "先搜AI", hideTabbar: true },
  },
  {
    path: "/debug/parameter-monitor",
    component: ParameterMonitor,
    meta: { title: "参数监控" },
  },
];
// pc端路由
const pcRoutes = [
  // { path: "/pc", component: PC },
  {
    path: "/",
    component: pcAutumnHome,
    meta: { title: "先搜", hideLayoutTop: true },
  },
  { path: "/pc", redirect: "/" },
  { path: "/pc/home", redirect: "/" },
  { path: "/info", redirect: "/pc/clue" },
  {
    path: "/info/publish",
    redirect: (to) => ({ path: "/pc/clue/publish", query: to.query }),
  },
  {
    path: "/info/detail/:id",
    redirect: (to) => ({
      path: `/pc/clue/detail/${to.params.id}`,
      query: to.query,
    }),
  },
  { path: "/brand/supplier-join", redirect: "/pc/clue/supplier-join" },
  {
    path: "/pc",
    component: Layout,
    children: [
      // 正式模式只注册 Spring 公共只读链路；显式 Fixture 模式保留原预览路由。
      ...pcPriceChannelRoutes,
      // 总客服先提供独立页面；不借用商品/订单会话接口创建虚假的业务锚点。
      {
        path: "agent-service",
        component: () => import("@/views/pc/agent-service/index.vue"),
        meta: { title: "总客服" },
      },
      {
        path: "home",
        component: pcHome,
        meta: {
          title: "大宗交易商城-pc",
          showSearch: true,
          backgroundColor: "transparent",
          textColor: "#3B3B3B",
        },
      },
      {
        path: "autumn-home",
        component: pcAutumnHome,
        meta: {
          title: "先搜",
          hideLayoutTop: true,
        },
      },
      {
        path: "featured",
        component: pcHome2,
        meta: {
          title: "大宗交易商城-pc",
          showSearch: true,
          backgroundColor: "transparent",
          textColor: "#3B3B3B",
        },
      },
      {
        path: "cshome",
        component: pcCshHome,
        meta: {
          title: "大宗交易商城测试-pc",
          showSearch: true,
          backgroundColor:
            "linear-gradient(180deg, #000000 23%, rgba(0, 0, 0, 0) 100%)",
          textColor: "#ffffff",
        },
      },
      {
        path: "category",
        component: Category,
        meta: { title: "商务订购跟单（接单）" },
      },
      // { path: '/clueFollow', component: ClueFollow },
      {
        path: "clue",
        component: pcSupplyDemandHall,
        meta: { title: "供需信息" },
      },
      {
        path: "clue/publish",
        component: pcSupplyDemandPublish,
        meta: { title: "供需发布" },
      },
      {
        path: "clue/detail/:id",
        component: pcSupplyDemandHallDetail,
        meta: { title: "供需详情" },
      },
      {
        path: "clue/supplier-join",
        component: pcSupplierJoin,
        meta: { title: "企业入驻" },
      },
      { path: "clue/legacy", component: pcClue, meta: { title: "原供求" } },
      { path: "info", redirect: "/pc/clue" },
      {
        path: "info/publish",
        redirect: (to) => ({ path: "/pc/clue/publish", query: to.query }),
      },
      {
        path: "info/detail/:id",
        redirect: (to) => ({
          path: `/pc/clue/detail/${to.params.id}`,
          query: to.query,
        }),
      },
      { path: "brand", component: pcBrand, meta: { title: "品牌中心" } },
      {
        path: "brand/join",
        component: pcBrandJoin,
        meta: { title: "品牌入驻" },
      },
      {
        path: "brand/detail",
        component: pcBrandDetail,
        meta: { title: "品牌详情" },
      },
      {
        path: "company/home",
        component: pcCompanyHome,
        meta: { title: "公司主页" },
      },
      { path: "brand/supplier-join", redirect: "/pc/clue/supplier-join" },
      {
        path: "wiki",
        component: pcWiki,
        // 与首页共用同一套覆盖式透明导航样式；详情页保持总前端普通导航。
        meta: {
          title: "芯片百科",
          backgroundColor: "transparent",
          textColor: "#3B3B3B",
          showSearch: true,
          showUserInfo: true,
        },
      },
      {
        path: "wiki/detail/:id",
        component: pcWikiDetail,
        meta: { title: "芯片百科详情" },
      },
      {
        path: "wiki/community",
        component: () => import("@/views/pc/wiki/userQuestions.vue"),
        meta: { title: "用户问答", showUserInfo: true },
      },
      {
        path: "wiki/questions",
        component: pcWikiCommunity,
        meta: { title: "知道" },
      },
      {
        path: "wiki/knowledge/:id",
        component: () => import("@/views/pc/wiki/knowledgeDetail.vue"),
        meta: { title: "百科参数问答" },
      },
      {
        path: "wiki/questions/detail/:id",
        component: pcWikiQuestionDetail,
        meta: { title: "问答详情" },
      },
      {
        path: "wiki/topics/:slug",
        component: pcWikiTopic,
        meta: { title: "推荐专题" },
      },
      {
        path: "wiki/questions/:id",
        component: pcWikiQuestions,
        meta: { title: "百科问答" },
      },
      { path: "follow", component: pcFollow, meta: { title: "跟单" } },
      {
        path: "follow/pendingFollow",
        component: pcPendingFollow,
        meta: { title: "谈判接单" },
      },
      {
        path: "follow/swPendingFollow",
        component: pcswPendingFollow,
        meta: { title: "商务接单" },
      },
      {
        path: "source/publish",
        component: pcPublishCenter,
        meta: { title: "发布中心" },
      },
      {
        path: "source/publish/fast",
        redirect: (to) => ({
          path: "/pc/source/publish",
          query: { ...to.query, tab: "featured" },
        }),
      },
      {
        path: "product/fastBuy",
        component: pcQuickOrder,
        meta: { title: "快捷下单" },
      },
      {
        path: "source/publishGoods",
        component: pcPublishGoods,
        meta: { title: "发布货源商品" },
      },
      {
        path: "clue/clueDetail",
        component: pcClueDetail,
        meta: { title: "货源详情" },
      },
      {
        path: "clue/clueEdit",
        component: pcClueEdit,
        meta: { title: "货源编辑" },
      },
      {
        path: "about",
        component: pcAbout,
        meta: { title: "关于先搜", transparentNav: true },
      },
      {
        path: "products",
        component: pcProducts,
        meta: { title: "产品介绍", transparentNav: true },
      },
      {
        path: "follow/tpr/editPreOrder",
        component: pcEditPreOrder,
        meta: { title: "修改意向单" },
      },
      {
        path: "follow/tpr/confirmPreOrder",
        component: pcConfirmPreOrder,
        meta: { title: "确认意向单" },
      },

      //动态路由传参
      {
        path: "prodetail/:id",
        component: pcProDetail,
        meta: { title: "商品详情" },
      },
      {
        path: "shopcart",
        component: pcShopCart,
        meta: { title: "购物车" },
      },
      {
        path: "buynow",
        component: pcBuyNow,
        meta: { title: "购买意向单" },
      },
      {
        path: "follow/generateTradeContract",
        component: pcGenerateTradeContract,
        meta: { title: "生成交易合同" },
      },
      {
        path: "follow/confirmTradeContract",
        component: pcconfirmTradeContract,
        meta: { title: "确认交易合同" },
      },
      {
        path: "follow/fastTradeContract",
        component: pcFastTradeContract,
        meta: { title: "快捷生成交易合同" },
      },
      {
        path: "follow/confirmFastTradeContract",
        component: pcConfirmFastTradeContract,
        meta: { title: "确认快捷下单合同" },
      },
      {
        path: "follow/outboundOrderAudit",
        component: pcOutboundOrderAudit,
        meta: { title: "出库单审核" },
      },
      {
        path: "follow/fastTradeContractDetail",
        component: pcFastTradeContractDetail,
        meta: { title: "查看快捷销售合同详情" },
      },
      {
        path: "follow/fastPurchaseContractDetail",
        component: pcFastPurchaseContractDetail,
        meta: { title: "查看快捷采购合同详情" },
      },
      {
        path: "follow/fastPurchaseContract",
        component: pcFastPurchaseContract,
        meta: { title: "快捷生成采购合同" },
      },
      {
        path: "follow/confirmFastPurchaseContract",
        component: pcConfirmFastPurchaseContract,
        meta: { title: "确认快捷采购合同" },
      },
      {
        path: "follow/fastPurchasePayment",
        component: pcFastPurchasePayment,
        meta: { title: "发起采购付款流程" },
      },
      {
        path: "follow/confirmFastPurchasePayment",
        component: pcConfirmFastPurchasePayment,
        meta: { title: "确认采购付款流程" },
      },
      {
        path: "follow/selectPaymentMethod",
        component: pcSelectPaymentMethod,
        meta: { title: "选择付款方式" },
      },
      {
        path: "follow/uploadPaymentVoucher",
        component: pcSelectPaymentMethod,
        meta: { title: "上传付款凭证" },
      },
      {
        path: "bindGoods",
        component: pcBindGoods,
        meta: { title: "绑定商品" },
      },
      {
        path: "follow/confirmFastTradeInvoice",
        component: pcConfirmFastTradeInvoice,
        meta: { title: "确认销售发票" },
      },
      {
        path: "follow/tprFollowDetail/:id",
        component: pctprFollowDetail,
        meta: { title: "谈判人跟单详情" },
      },
      {
        path: "follow/swFollowDetail/:id",
        component: pcswFollowDetail,
        meta: { title: "商务跟单详情" },
      },
      {
        path: "search",
        component: pcSearch,
        meta: { title: "全站搜索", hideLayoutTop: true, searchResultHeader: true },
      },
      {
        path: "myAi",
        component: pcmyAi,
        meta: { title: "先搜AI" },
      },
      {
        path: "bid",
        component: pcBid,
        meta: {
          title: "芯片竞标",
          backgroundColor: "transparent",
          textColor: "#3B3B3B",
          transparentNav: true,
          showSearch: true,
          showUserInfo: true,
        },
      },
      {
        path: "bid/publish",
        component: pcBidPublish,
        meta: { title: "竞标发布", showSearch: true, showUserInfo: true },
      },
      {
        path: "my/shopHome",
        component: pcShopHome,
        meta: { title: "谈判人主页", showSearch: false, showUserInfo: true },
      },
      {
        path: "user/bid-audits/review/:batchId",
        component: pcBidAuditReview,
        meta: { title: "竞标审核" },
      },
      {
        path: "myxg",
        component: pcmy,
        children: [
          {
            path: "reportData",
            component: pcReportData,
            meta: { title: "数据看板", type: "my" },
          },
          {
            path: "/pc/user",
            component: pcUser,
            meta: { title: "我的", type: "my" },
          },
          {
            path: "/pc/content-translations",
            component: () =>
              import("@/views/pc/my/ContentTranslationManage.vue"),
            meta: { title: "动态译文管理", type: "my" },
          },
          {
            path: "/pc/contract-translations",
            component: () =>
              import("@/views/pc/my/ContractTranslationManage.vue"),
            meta: { title: "合同译文审核", type: "my" },
          },
          {
            path: "/pc/user/wiki",
            component: pcmyWiki,
            meta: { title: "审核管理", type: "my" },
          },
          {
            path: "/pc/user/wiki/publish",
            component: pcmyWikiPublish,
            meta: { title: "发布百科", type: "my" },
          },
          {
            path: "/pc/user/wiki/mine",
            component: pcmyWiki,
            meta: { title: "我的发布", type: "my" },
          },
          {
            path: "/pc/user/wiki/collection",
            component: pcmyWikiCollection,
            meta: { title: "我的收藏", type: "my" },
          },
          {
            path: "/pc/user/wiki/questions",
            component: pcmyWikiQuestions,
            meta: { title: "我的问答", type: "my" },
          },
          ...(priceChannelFlags.readSource === "spring-api"
            ? priceChannelPersonalRoutes
            : []),
          {
            path: "/pc/my/myBalance",
            component: pcmyBalance,
            meta: { title: "我的钱包", type: "my" },
          },
          {
            path: "myTransactionOrder",
            component: pcmyTransactionOrder,
            meta: { title: "交易订单", type: "my" },
          },
          {
            path: "myGoods",
            component: pcmyGoods,
            meta: { title: "商品中心", type: "my" },
          },
          {
            path: "goodsLibrary",
            component: pcGoodsLibrary,
            meta: { title: "商品库", type: "my" },
          },
          {
            path: "myBrand",
            component: pcMyBrand,
            meta: { title: "品牌管理", type: "my" },
          },
          {
            path: "myTransactionOrderDetail",
            component: pcmyTransactionOrderDetail,
            meta: { title: "交易订单详情", type: "my" },
          },
          {
            path: "myBuyOrderList",
            component: pcmyBuyOrderList,
            meta: { title: "我的购买订单", type: "my" },
          },
          {
            path: "myBuyOrderDetail",
            component: pcmyBuyOrderDetail,
            meta: { title: "购买订单详情", type: "my" },
          },
          {
            path: "mySaleOrderList",
            component: pcmySaleOrderList,
            meta: { title: "我的销售订单", type: "my" },
          },
          {
            path: "mySaleOrderDetail",
            component: pcmySaleOrderDetail,
            meta: { title: "销售订单详情", type: "my" },
          },
          {
            path: "myPublishClue",
            component: pcmyPublishClue,
            meta: { title: "我发布的线索", type: "my" },
          },
          {
            path: "mySaleGoods",
            component: pcmySaleGoods,
            meta: { title: "我的销售商品", type: "my" },
          },
          {
            path: "myPreOrderList",
            component: pcmyPreOrderList,
            meta: { title: "我的意向订购", type: "my" },
          },
          {
            path: "myContractList",
            component: pcmyContractList,
            meta: { title: "我的合同", type: "my" },
          },
          {
            path: "myYanHuo",
            component: pcmyYanHuo,
            meta: { title: "我的验货", type: "my" },
          },
          {
            path: "myYanHuoDetail2",
            component: pcmyYanHuoDetail2,
            meta: { title: "验货详情2", type: "my" },
          },
          {
            path: "myPreOrderDetail",
            component: pcmyPreOrderDetail,
            meta: { title: "商品订单详情", type: "my" },
          },
          {
            path: "myEvaluate",
            component: pcmyEvaluate,
            meta: { title: "评价", type: "my" },
          },
          {
            path: "messageCenter",
            component: pcMessageCenter,
            meta: { title: "消息管理", type: "my" },
          },
          {
            path: "supplierList",
            component: pcSupplierList,
            meta: { title: "供应商管理", type: "my" },
          },
          {
            path: "/pc/follow/outboundOrderList",
            component: () => import("@/views/pc/follow/sw/outboundOrderList.vue"),
            meta: { title: "出库单列表", type: "my" },
          },
          // 百科相关子路由
          {
            path: "/pc/encyclopedia/specification",
            component: pcSpecificationManage,
            meta: { title: "规格书管理", type: "my" },
          },
          {
            path: "/pc/encyclopedia/publish",
            redirect: "/pc/encyclopedia/publish/content",
            meta: { title: "发布管理", type: "my" },
          },
          {
            path: "/pc/encyclopedia/publish/content",
            component: pcContentPublish,
            meta: { title: "内容发布", type: "my" },
          },
          {
            path: "/pc/encyclopedia/publish/publishSuccess",
            component: pcSpecificationPublishSuccess,
            meta: { title: "发布成功", type: "my" },
          },
          {
            path: "/pc/encyclopedia/publish/batch",
            component: pcUser,
            meta: { title: "批量发布", type: "my" },
          },
          {
            path: "/pc/encyclopedia/collection",
            redirect: "/pc/encyclopedia/collection/rule",
            meta: { title: "采集管理", type: "my" },
          },
          {
            path: "/pc/encyclopedia/collection/rule",
            component: pcUser,
            meta: { title: "采集规则管理", type: "my" },
          },
          {
            path: "/pc/encyclopedia/collection/settings",
            component: pcUser,
            meta: { title: "采集设置管理", type: "my" },
          },
          {
            path: "/pc/encyclopedia/list",
            component: pcUser,
            meta: { title: "列表管理", type: "my" },
          },
          // 供应需求相关子路由
          {
            path: "/pc/supply-demand",
            redirect: "/pc/supply-demand/supply",
            meta: { title: "供应需求", type: "my" },
          },
          {
            path: "/pc/supply-demand/hall",
            redirect: "/pc/clue",
            meta: { title: "供需大厅", type: "my" },
          },
          {
            path: "/pc/supply-demand/supply",
            component: pcSupplyPublish,
            meta: { title: "供应发布", type: "my" },
          },
          {
            path: "/pc/supply-demand/demand",
            component: pcDemandPublish,
            meta: { title: "需求发布", type: "my" },
          },
          {
            path: "/pc/supply-demand/simple-supply",
            component: pcSimpleSupplyPublish,
            meta: { title: "简洁供应发布", type: "my" },
          },
          {
            path: "/pc/supply-demand/simple-demand",
            component: pcSimpleDemandPublish,
            meta: { title: "简洁需求发布", type: "my" },
          },
          {
            path: "/pc/supply-demand/batch",
            component: pcSupplyDemandBatch,
            meta: { title: "批量发布", type: "my" },
          },
          {
            path: "/pc/supply-demand/member-identity",
            redirect: "/pc/member-identity/list",
          },
          {
            path: "/pc/customer-management",
            redirect: "/pc/customer-management/customers",
          },
          {
            path: "/pc/customer-management/:tab",
            component: pcCustomerManagement,
            meta: { title: "客户管理", type: "my" },
          },
          {
            path: "/pc/member-level",
            redirect: "/pc/member-level/list",
          },
          {
            path: "/pc/member-level/:tab",
            component: pcMemberLevel,
            meta: { title: "会员等级", type: "my" },
          },
          {
            path: "/pc/member-identity",
            redirect: "/pc/member-identity/list",
          },
          {
            path: "/pc/member-identity/:tab",
            component: pcSupplyDemandMemberIdentity,
            meta: { title: "会员身份", type: "my" },
          },
          {
            path: "/pc/bidding-management",
            redirect: "/pc/bidding-management/list",
          },
          {
            path: "/pc/bidding-management/:tab",
            component: pcBiddingManagement,
            meta: { title: "竞标管理", type: "my" },
          },
          {
            path: "/pc/user/bid-audits",
            component: pcBidAuditCenter,
            meta: { title: "竞标审核中心", type: "my" },
          },
          // 账号设置
          {
            path: "/pc/account-setting/personal-info",
            component: () =>
              import("@/views/pc/my/accountSetting/personalInfo.vue"),
            meta: { title: "个人资料", type: "my" },
          },
          {
            path: "/pc/account-setting/company-info",
            component: () =>
              import("@/views/pc/my/accountSetting/companyInfo.vue"),
            meta: { title: "企业资料", type: "my" },
          },
          {
            path: "/pc/account-setting/security",
            component: () =>
              import("@/views/pc/my/accountSetting/security.vue"),
            meta: { title: "安全设置", type: "my" },
          },
          {
            path: "/pc/account-setting/verification",
            component: () =>
              import("@/views/pc/my/accountSetting/verification.vue"),
            meta: { title: "账号认证", type: "my" },
          },
        ],
      },
      {
        path: "/pc/supply-demand/supply-list",
        component: pcSupplyList,
        meta: { title: "供应列表" },
      },
      {
        path: "/pc/supply-demand/hall-detail/:id",
        redirect: (to) => ({
          path: `/pc/clue/detail/${to.params.id}`,
          query: to.query,
        }),
        meta: { title: "供需详情" },
      },
      {
        path: "/pc/supply-demand/supply-detail/:id",
        component: pcSupplyDetail,
        meta: { title: "供应详情" },
      },
      {
        path: "/pc/supply-demand/demand-list",
        component: pcDemandList,
        meta: { title: "需求列表" },
      },
      {
        path: "applybroker",
        component: pcapplybroker,
        meta: { title: "申请成为谈判人" },
      },
      { path: "realname", component: pcrealname, meta: { title: "实名认证" } },
      {
        path: "specificationPublish",
        component: pcSpecificationPublish,
        meta: { title: "规格书发布" },
      },
      {
        path: "specification/publishSuccess",
        component: pcSpecificationPublishSuccess,
        meta: { title: "发布成功" },
      },
      // {
      //   path: "specification/:brand/:model",
      //   component: pcSpecificationDetail,
      //   meta: { title: "规格书详情" },
      // },
      {
        path: "specification/detail/:id",
        component: pcSpecificationDetail,
        meta: { title: "规格书详情" },
      },
    ],
  },

  // 未处理的路由
  { path: "/pc/login", component: Login, meta: { title: "登录" } },
  { path: "/cart", component: Cart, meta: { title: "购物车" } },
  { path: "/search", component: Search, meta: { title: "搜索" } },
  { path: "/searchlist", component: SearchList, meta: { title: "商品列表" } },
  {
    path: "/preOrderDetail/:id",
    component: preOrderDetail,
    meta: { title: "跟单详情" },
  },
  { path: "/pay", component: Pay },
  { path: "/buy", component: Buy },
  { path: "/preOrderSuccess", component: PreOrderSuccess },
  { path: "/myorder", component: MyOrder },

  { path: "/sw/myCreateOrder", component: myCreateOrder },
  {
    path: "/externalPay",
    component: externalPay,
    meta: { title: "对外支付" },
  },
  {
    path: "/externalPayInfo",
    component: externalPayInfo,
    meta: { title: "对外支付" },
  },
  {
    path: "/myxg/myOrderIntention",
    component: myOrderIntention,
    meta: { title: "我的意向单" },
  },
  {
    path: "/myxg/myFollowOrderList",
    component: myFollowOrderList,
    meta: { title: "跟单订单" },
  },
  { path: "/myxg/myDetails", component: myDetails, meta: { title: "详情" } },
  {
    path: "/my/myHome",
    component: myHome,
    meta: { title: "个人主页" },
  },
  {
    path: "/debug/parameter-monitor",
    component: ParameterMonitor,
    meta: { title: "参数监控" },
  },
];
// 源 Demo 使用 hash 路由；迁入 H5 history Router 后保留旧收藏深链的路径与 Query。
if (
  priceChannelFlags.readSource === "fixture" &&
  typeof window !== "undefined"
) {
  const legacyPath = window.location.hash.slice(1);
  if (
    /^\/pc\/(?:pricechannel|user\/pricechannel)(?:\/|\?|$)/.test(legacyPath) &&
    ["/", "/index.html"].includes(window.location.pathname)
  ) {
    window.history.replaceState(window.history.state, "", legacyPath);
  }
}

// 本机排版检查复用真实移动端搜索页，不启用示例数据。
if (process.env.NODE_ENV === "development") {
  const mobileSearchPreview = { path: "/pc/mobile-search-preview", component: Search };
  routes.push(mobileSearchPreview);
  pcRoutes.push(mobileSearchPreview);
}

const router = new VueRouter({
  mode: "history",
  routes: isMobile ? routes : pcRoutes,
  scrollBehavior(to, from, savedPosition) {
    // 正式行情由缓存页面恢复全部滚动容器，避免全局回顶覆盖列表返回位置。
    if (
      priceChannelFlags.readSource !== "fixture" &&
      /^pricechannel-display(?:-|$)/.test(to.name || "")
    )
      return false;
    if (savedPosition) {
      // 浏览器前进/后退时，等待目标页面完成一次 DOM 更新后再恢复位置。
      // 百科列表包含异步内容，立即滚动容易因为页面高度尚未恢复而回到顶部。
      return new Promise((resolve) => {
        Vue.nextTick(() => resolve(savedPosition));
      });
    }
    return { x: 0, y: 0 };
  },
});

//全局前置导航守卫
//to:到哪里去（路径，参数）
//from:从哪里来（路径，参数）
//next:是否放行

//定义数组 专门用户存放所有需要权限访问的页面
const authUrls = [
  "/pay",
  "/myorder",
  "/myxg/messageCenter",
  "/source/publish",
  "/source/publish/fast",
  "/product/fastBuy",
  "/bid/publish",
];
// 先搜 AI 页面本身是公开页面；游客额度只在发送消息时由 AI 会话逻辑控制。
// 不要把 /myAi 放进 authUrls，否则 PC 自动生成的 /pc/myAi 也会被强制登录。
// 动态业务译文管理按本地试行策略仅要求登录。
const pcAuthUrls = [...authUrls.map((url) => `/pc${url}`), "/pc/content-translations"];
const pcAdminOnlyPrefixes = [
  "/pc/contract-translations",
  "/pc/member-level",
  "/pc/member-identity",
  "/pc/bidding-management/list",
];

const isAdminUser = (userInfo = {}) => {
  const roles = userInfo.roles || userInfo.roleKeys || [];
  return (
    userInfo.isAdmin === true ||
    (Array.isArray(roles) && roles.includes("admin"))
  );
};

const isWikiReviewer = (userInfo = {}) => {
  return isWikiReviewerAccount(userInfo, store.getters.token);
};

const isPcAdminOnlyPath = (path = "") => {
  return pcAdminOnlyPrefixes.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
};

console.log(pcAuthUrls);
router.beforeEach(async (to, from, next) => {
  if (process.env.NODE_ENV === "development" && to.path === "/pc/mobile-search-preview") {
    next();
    return;
  }

  console.log("to", to);
  // 通过Vue.prototype访问$device（需确保插件已安装）
  // const isMobile = Vue.prototype.$device.isMobile;
  console.log(`当前设备类型：${isMobile ? "移动设备" : "PC设备"}`);
  if (
    to.path === "/pc/my/pricechannel" ||
    to.path.startsWith("/pc/my/pricechannel/") ||
    to.path === "/pc/user/pricechannel" ||
    to.path.startsWith("/pc/user/pricechannel/")
  ) {
    if (!store.getters.token) {
      Message.warning("请先登录");
      if (typeof window !== "undefined")
        window.dispatchEvent(new Event("open-login-dialog"));
      next({ path: "/pc/home", query: { backUrl: to.fullPath } });
      return;
    }
    next();
    return;
  }
  // 该搜索首页由电脑和手机共用同一路径，手机端不能移除 /pc 前缀。
  if (to.path === "/pc/autumn-home") {
    next();
    return;
  }
  if (to.path === "/pc/user/wiki") {
    const token = store.getters.token;
    if (!token) {
      Message.warning("请先登录");
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("open-login-dialog"));
      }
      next({ path: "/pc/home", query: { backUrl: to.fullPath } });
      return;
    }
    let reviewerAllowed = isWikiReviewer(store.state.user.userDetails || {});
    try {
      const accessResponse = await getWikiReviewAccess();
      reviewerAllowed = Boolean(
        accessResponse && accessResponse.data && accessResponse.data.allowed,
      );
      rememberWikiReviewerAccess(token, reviewerAllowed);
    } catch (error) {
      reviewerAllowed = false;
      rememberWikiReviewerAccess(token, false);
    }
    if (!reviewerAllowed) {
      Message.error("当前账号没有百科审核权限");
      next({ path: "/pc/user/wiki/mine" });
      return;
    }
    next();
    return;
  }
  // console.log(to, from, next);
  // 看to.path是否在authUrls中出现过
  //非权限页面直接放行
  if (isPcAdminOnlyPath(to.path)) {
    const token = store.getters.token;
    if (!token) {
      Message.warning("请先登录");
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("open-login-dialog"));
      }
      next({
        path: "/pc/home",
        query: { backUrl: to.fullPath },
      });
      return;
    }
    try {
      await store.dispatch("user/getUserInfo");
    } catch (error) {
      console.error("获取用户信息失败:", error);
    }
    if (!isAdminUser(store.state.user.userDetails || {})) {
      Message.error("暂无权限访问该页面");
      next({ path: "/pc/home" });
      return;
    }
    next();
    return;
  }

  if (!authUrls.includes(to.path) && !pcAuthUrls.includes(to.path)) {
    if (
      isMobile &&
      (to.path.startsWith("/pc/pricechannel/") ||
        (priceChannelFlags.readSource === "fixture" &&
          /^\/pc\/user\/pricechannel(?:\/|$)/.test(to.path)))
    ) {
      next();
      return;
    }
    if (!isMobile) {
      // 给to.meta补充默认值：如果没配置showSearch，默认false；同理showUserInfo
      to.meta.showSearch = to.meta.showSearch ?? false; // Vue2不支持??的话用 to.meta.showSearch !== undefined ? to.meta.showSearch : false
      to.meta.showUserInfo = to.meta.showUserInfo ?? true; // 同上
      if (!to.path.includes("/pc") && to.path !== "/") {
        // 方式1：通过 next 传递新路由（推荐）
        next({
          path: `/pc${to.path}`, // 拼接 /pc 前缀
          query: to.query, // 保留原查询参数
          params: to.params, // 保留原路径参数
          // 其他需要保留的路由属性（如 meta、hash 等）
        });
      } else {
        next();
      }
    } else {
      if (to.path.includes("/pc") && to.path !== "/") {
        // 方式1：通过 next 传递新路由（推荐）
        next({
          path: to.path.replace("/pc", ""), // 正确去掉 /pc 前缀
          query: to.query, // 保留原查询参数
          params: to.params, // 保留原路径参数
          // 其他需要保留的路由属性（如 meta、hash 等）
        });
      } else {
        next();
      }
    }
    return;
  }
  //是权限页面 需要判断token
  const token = store.getters.token;
  // 权限页面-判断是否有token
  if (token) {
    const isBidPublish = ["/bid/publish", "/pc/bid/publish"].includes(to.path);
    const hasCachedUser = Object.keys(
      store.state.user.userDetails || {},
    ).length;
    try {
      // 发布竞标只要求已登录；已有用户缓存时不再用重复请求阻塞路由切换。
      if (!isBidPublish || !hasCachedUser) {
        await store.dispatch("user/getUserInfo");
      }
      // 获取更新后的用户信息
      var userInfo = store.state.user.userDetails;
      // 快捷下单只校验登录、实名认证和内部角色，不依赖精选发布身份。
      if (to.path === "/product/fastBuy" || to.path === "/pc/product/fastBuy") {
        if (userInfo && userInfo.authnStatus == 1) {
          if (
            userInfo.businessType == "20" ||
            userInfo.businessType == "30" ||
            userInfo.businessType == "40"
          ) {
            Dialog({
              title: "温馨提示",
              message: "您暂无此功能权限！",
            });
          } else {
            next();
          }
        } else {
          showRealnameConfirm(from);
        }
        return;
      }
      // 发布货源线索页面 需要判断实名认证状态
      if (
        to.path == "/source/publish" ||
        to.path == "/pc/source/publish" ||
        to.path == "/source/publish/fast" ||
        to.path == "/pc/source/publish/fast"
      ) {
        console.log("发布货源线索页面");
        if (userInfo && userInfo.authnStatus == 1) {
          if (
            // 其他内部角色-除了普通用户、谈判人
            userInfo.businessType == "20" ||
            userInfo.businessType == "30" ||
            userInfo.businessType == "40"
          ) {
            Dialog({
              title: "温馨提示",
              message: "您暂无此功能权限！",
            });
          } else {
            // 普通用户和谈判人均可进入快捷发布；普通用户页面默认公开发布。
            next();
          }
        } else {
          console.log("需要实名认证，重定向到实名页");
          showRealnameConfirm(from);
        }
        return;
      }
      next();
    } catch (error) {
      console.error("路由跳转时获取用户信息失败:", error);
      // 即使获取用户信息失败，也允许继续访问，避免影响用户体验
      next();
    }
  } else {
    if (isMobile) {
      if (from.path == "/login") {
        return;
      } else {
        console.log("需要登录，重定向到登录页");
        Toast.fail("需要登录，重定向到登录页");
        router.replace({
          path: "/login",
          query: { backUrl: to.fullPath },
        });
      }
    } else {
      Message.warning("请先登录");
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("open-login-dialog"));
      }
      next({
        path: "/pc/home",
        query: { backUrl: to.fullPath },
      });
    }
  }
});

export default router;
